export const _en = {
    addButton: {
        label: "Add a Service Provider"
    },
    toggleDeleted: {
        label: "Show deleted data"
    },
    dialog: {
        add: {
            title: "Add a Service Provider",
            buttons: {
                save: "Save",
                cancel: "Cancel"
            }
        }
    }
};


export const _fr = {
    addButton: {
        label: "Société"
    },
    toggleDeleted: {
        label: "Afficher les sociétés archivées"
    },
    dialog: {
        add: {
            title: "Ajout d'une société",
            buttons: {
                save: "Sauvegarder",
                cancel: "Annuler"
            }
        }
    }
};